import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import './DeckViewer.css';
import Card from '../../components/cards/Card';
import CardBox from '../../components/cards/CardBox';
import { Tooltip } from 'reactstrap';
import User from '../../User';
import Library from '../utility/Library';

export default class DeckViewer extends Component {

  state = {
    focus: null
  }

  constructor (props) {

    super(props);
    this.canSelect = false;
  }

  componentDidMount() {

    setTimeout(() => this.canSelect = true, 200);
  }

  render () {

    let left = null, right = null;

    let typesort = {
      "attack": 1,
      "special": 2,
      "hex": 3,
      "trigger": 4
    }

    let sorting = (basea, baseb) => {

      let a = basea.card.card ? basea.card : basea;
      let b = baseb.card.card ? baseb.card : baseb;
      let modela = a.card.card || a.card;
      let modelb = b.card.card || b.card;

      if (a.status === "disabled" && b.status !== "disabled")
        return 1;
      if (b.status === "disabled" && a.status !== "disabled")
        return -1;

      if (!!modela.locked !== !!modelb.locked)
        return modela.locked ? 1 : -1;

      let augmenta = Library.hasSubtype(modela, "augment");
      let augmentb = Library.hasSubtype(modelb, "augment");
      if (augmenta !== augmentb)
        return augmenta ? 1 : -1;

      if (modela.starter !== modelb.starter)
        return (modelb.starter ? 1 : 0) - (modela.starter ? 1 : 0);
      if (modela.starter && modelb.starter)
        return modela.key - modelb.key;
      let raritya = modela.rarity || 1000;
      let rarityb = modelb.rarity || 1000;
      if (raritya !== rarityb)
        return raritya - rarityb;
      let typea = typesort[modela.type];
      let typeb = typesort[modelb.type];
      if (typea !== typeb)
        return typea - typeb;
      let manaa = isNaN(modela.mana) ? 1000 : modela.mana;
      let manab = isNaN(modelb.mana) ? 1000 : modelb.mana;
      if (manaa !== manab)
        return manaa - manab;
      return modela.name.localeCompare(modelb.name);
    }
    
    return (
      <div className="card-dropper deck-viewer">
        <div className="lightbox-container" onClick={() => {
          if (this.canSelect)
            this.props.onClose();
        }}>
          <div className="lightbox-inner">
            <div className="card-dropper-inner">
              <div className="card-dropper-options">
              {
                this.props.deck.map((card, i) => { return {card, index:i}}).sort(sorting).map(sorted => {
                  const model = sorted.card.card || sorted.card;
                  const isAugment = Library.hasSubtype(model, "augment");
                  return <div key={sorted.index} className={"card-dropper-option " + sorted.card.status + (isAugment ? " augment" : "")} onClick={e => {
                    if (!this.canSelect)
                      return;
                    if (this.props.onSelect)
                      this.props.onSelect(sorted.index);
                    else
                      this.setState({focus: sorted.card.card || sorted.card});
                    e.stopPropagation();
                  }}>
                    <div className="card-dropper-option-inner">
                      <Card src={Library.getUpgradedCard((sorted.card.card || sorted.card).key)}/>
                    </div>
                    {
                      this.props.info &&
                      <div className="deckbuild-info" onClick={e => {
                        if (this.canSelect) {
                          this.setState({focus: Library.getUpgradedCard((sorted.card.card || sorted.card).key)});
                          e.stopPropagation();
                        }
                      }}>
                        <img className="deckbuild-info-icon" src={'/images/info.png'}/>
                      </div>
                    }
                    {
                      model.locked && <div className="deckbuild-lock"><img className="deckbuild-lock-icon" src="/images/statuses/Locked.png"/></div>
                    }
                    {
                      sorted.card.new && <div className="deckbuild-new">{translate("New")}</div>
                    }
                  </div>
                })
              }
              </div>
            </div>
          </div>
        </div>
        {
          this.state.focus ?
          <div>
            <CardBox left={left ? () => this.setState({focus:left}) : undefined} right={right ? () => this.setState({focus:right}) : undefined} src={this.state.focus} open={true} onClose={() => this.setState({focus:null})}/>
          </div> : ""
        }
      </div>
    );
  }
}

